import React, { useRef, useState, useEffect } from "react";
import { FellouButton } from "@/ui-components-next/FellouButton";
import "./styles.scss";

interface SegmentedOption {
  label: string | JSX.Element;
  value: string;
}

interface CustomSegmentedProps {
  options: SegmentedOption[];
  value: string;
  onChange: (value: string) => void;
  block?: boolean;
  isBackground?: boolean;
  isFixedTags?: boolean;
}

const CustomSegmented: React.FC<CustomSegmentedProps> = ({
  options,
  isBackground = true,
  value,
  isFixedTags,
  onChange,
  block = false,
}) => {
  const [indicatorStyle, setIndicatorStyle] = useState({});
  const [isShowScrollBtn, setIsShowScrollBtn] = useState(false);
  const segmentRefs = useRef<(HTMLDivElement | null)[]>([]);
  const segmentRef = useRef<HTMLDivElement | null>(null);

  const updateIndicatorStyle = () => {
    const activeIndex = options.findIndex((option) => option.value === value);
    if (activeIndex >= 0 && segmentRefs.current[activeIndex]) {
      const activeSegment = segmentRefs.current[activeIndex];
      if (activeSegment) {
        setIndicatorStyle({
          width: `${activeSegment.offsetWidth}px`,
          transform: `translateX(${activeSegment.offsetLeft}px)`,
        });
      }
    }
  };

  const handleScroll = (direction: "left" | "right") => {
    // 简单的实现点击按钮左右滑动 每次滑动的距离是一页的宽度
    if (segmentRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = segmentRef.current;
      const scrollAmount = clientWidth;
      segmentRef.current.scrollTo({
        left: direction === "left" ? scrollLeft - scrollAmount : scrollLeft + scrollAmount,
        behavior: "smooth",
      });
    }
  };
  // 监听窗口大小变化 隐藏滚动按钮
  useEffect(() => {
    const handleResize = () => {
      // 判断segmentRef内容是否可以滑动
      let isScrolling = false;
      if (segmentRef.current) {
        const { scrollWidth, clientWidth } = segmentRef.current;
        console.log(scrollWidth, clientWidth, "scrollWidth, clientWidth");
        isScrolling = scrollWidth > clientWidth;
      }
      setIsShowScrollBtn(isScrolling);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    updateIndicatorStyle();
  }, [value, options, segmentRef.current]);

  // 监听窗口大小变化，更新指示器位置
  useEffect(() => {
    const handleResize = () => {
      updateIndicatorStyle();
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [value, options]);

  return (
    <div className="custom-segmented-wrap">
      {isShowScrollBtn && (
        <FellouButton className="segmented-btn " onClick={() => handleScroll("left")}>
          <i className="icon iconfont icon-arrow-left-line"></i>
        </FellouButton>
      )}
      <div
        ref={(el) => { segmentRef.current = el; }}
        className={`custom-segmented ${block ? "block" : ""} ${isBackground ? "isBackground" : ""}`}
      >
        <div className="custom-segmented-inner ">
          {options.map((option, index) => (
            <div
              key={option.value}
              ref={(el) => { segmentRefs.current[index] = el; }}
              className={`custom-segmented-item ${isFixedTags === true ? "custom-segmented-fixed-item" : ""} ${value === option.value ? "active" : ""}`}
              onClick={() => onChange(option.value)}
            >
              {option.label}
            </div>
          ))}
          <div className="custom-segmented-indicator" style={indicatorStyle} />
        </div>
      </div>
      {isShowScrollBtn && (
        <FellouButton className="segmented-btn" onClick={() => handleScroll("right")}>
          <i className="icon iconfont icon-a-arrow-right-line1"></i>
        </FellouButton>
      )}
    </div>
  );
};

export default CustomSegmented;
